import * as React from "react";
import type { SVGProps } from "react";
const SvgOnePerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#one-person_svg__a)">
      <path d="M12 12.41c-2.22 0-4.06-1.74-4.19-3.96l-.12-2.18C7.69 3.89 9.58 2 11.9 2h.19c2.32 0 4.21 1.89 4.21 4.22l-.13 2.24a4.19 4.19 0 0 1-4.19 3.96zM11.9 4c-1.22 0-2.21.99-2.21 2.22l.12 2.12A2.2 2.2 0 0 0 12 10.41a2.2 2.2 0 0 0 2.19-2.07l.12-2.18c0-1.17-1-2.16-2.22-2.16z" />
      <path d="M21 22H3c-.55 0-1-.45-1-1v-4c0-2.76 2.24-5 5-5h10c2.76 0 5 2.24 5 5v4c0 .55-.45 1-1 1M4 20h16v-3c0-1.65-1.35-3-3-3H7c-1.65 0-3 1.35-3 3z" />
      <path d="M7 22c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1M17 22c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="one-person_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOnePerson;
